var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconSerialnumber = function SvgIconSerialnumber(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1B1A1F",
    d: "M5.667 13v-2.667H3v-1h2.667V6.667H3v-1h2.667V3h1v2.667h2.666V3h1v2.667H13v1h-2.667v2.666H13v1h-2.667V13h-1v-2.667H6.667V13zm1-3.667h2.666V6.667H6.667z"
  })));
};
export default SvgIconSerialnumber;